import { OPEN_TOASTER, RESET, TOGGLE_VISIBILITY } from '../types/toaster';

export type ToasterState = {
  toasterVisible: boolean;
  toasterTitle: string;
  toasterMessage: string;
  toasterType: string;
};

const initialState: ToasterState = {
  toasterVisible: false,
  toasterTitle: '',
  toasterMessage: '',
  toasterType: 'success',
};

export default function reducer(
  state: ToasterState = initialState,
  action: any
) {
  switch (action.type) {
    case RESET:
      return { ...initialState };
    case TOGGLE_VISIBILITY:
      return { ...state, toasterVisible: action.payload };
    case OPEN_TOASTER:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
